import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDiskv2RPw0Z3n7dTkSgk3YofpleIRzStk",
  authDomain: "fight-night-cb9fc.firebaseapp.com",
  projectId: "fight-night-cb9fc",
  storageBucket: "fight-night-cb9fc.firebasestorage.app",
  messagingSenderId: "102780795747",
  appId: "1:102780795747:web:9b18c7b7a9722bfa73f156",
  measurementId: "G-Z3S3HJ6TLX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Set persistence to LOCAL (works better in iframes)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn('Firebase Auth persistence setup failed:', error);
});

export default app;

